module.exports = __webpack_public_path__ + "img/rice.b1a73d08.png";